import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getCookie } from '../@core/utils/get-cookie.utils';
import { MyDocumentsService } from '../services/my-documents.service';


@Injectable({
  providedIn: 'root',
})
export class MyDocumentsGuard implements CanActivate {
  loggedInStatus: boolean = false;

  constructor(private router: Router, private myDocumentsService: MyDocumentsService) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    const token = getCookie('myesse_access_token');

    if (this.loggedInStatus) {
      return true;
    }

    const usedIdp = getCookie('active_idp');
    if (usedIdp === 'ias-white-oidc' || usedIdp === 'ias-blue-oidc') {
      localStorage.setItem('oidc-login', usedIdp);
    } else {
      return false;
    }

    const result = await this.myDocumentsService.validateToken(token!);
    this.loggedInStatus = result;

    if (this.loggedInStatus) {
    } else {
      this.router.navigate(['/auth/login']);
    }

    return this.loggedInStatus;
  }
}
